import { Text, FilterAltIcon } from '@mercai/clever'

import { formatCurrency, formatNumber } from '@/helpers'

import { generateClassesMetric } from './metric.constants'

import styles from './metric.module.css'

import { MetricProps, MetricsProps } from './metric.type'

export const Metric = ({
  value,
  creditValue,
  total,
  label,
  decimalPlaces = 2,
  isActiveFilter,
  className,
  onClickFilter,
}: MetricProps) => {
  const getPercentage = () => {
    return formatNumber(
      (value || 0 / (total || 1)) * 100,
      'es-MX',
      decimalPlaces,
    )
  }

  return (
    <li className={generateClassesMetric(isActiveFilter)}>
      <div className={styles['metrics-item-header']}>
        <Text className={styles['metrics-item-texts']}>{label}</Text>

        {onClickFilter && (
          <button
            onClick={() => onClickFilter()}
            className={styles['metrics-item-button']}
          >
            <FilterAltIcon
              className={isActiveFilter ? styles['is-active'] : ''}
            />
          </button>
        )}
      </div>

      <div className={styles['metrics-item-row']}>
        {value && (
          <Text variant="title-large">
            {formatNumber(value, 'es-MX', decimalPlaces)}
          </Text>
        )}

        {creditValue && (
          <Text
            variant="title-large"
            className={className ? styles[className] : ''}
          >
            {formatCurrency(Number(creditValue), 'es-MX', 'USD')}
          </Text>
        )}

        {total && (
          <Text variant="title-small" className={styles['metrics-item-texts']}>
            ({getPercentage()}%)
          </Text>
        )}
      </div>
    </li>
  )
}

export const Metrics = ({ metrics }: MetricsProps) => {
  return (
    <ul className={styles.metrics}>
      {metrics.map((metric) => (
        <Metric {...metric} key={metric.label} />
      ))}
    </ul>
  )
}
